import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";

@Component({
    selector: 'app-schedule-view-cancel',
    template: require('./scheduleViewDialogCancel.html')
})
export class ScheduleViewCancelDialog {

    constructor(@Inject(MAT_DIALOG_DATA) public data: any,
                @Inject(MatDialogRef<ScheduleViewCancelDialog>) public dialogRef: MatDialogRef<ScheduleViewCancelDialog>) {
    }

    closeThisDialog(value: any) {
        this.dialogRef.close(value);
    }

}
